"use client";

import { ReactNode } from "react";
import NextForm from "next/form";
import { GridRowId } from "@mui/x-data-grid-pro";
import { useCampaignDialogs } from "../Providers/CampaignDialogsContext";
import { useUnassignDialog } from "../Providers/UnassignDialogContext";
import { unassignCampaignsAction } from "../actions";

interface FormProps {
  children: ReactNode;
}

export default function Form({ children }: FormProps) {
  const { setRowSelectionModel } = useCampaignDialogs();

  const {
    campaignIdsToUnassign,
    closeUnassignDialog,
    userRowSelectionModel,
    setUserRowSelectionModel,
  } = useUnassignDialog();

  const handleAction = async (formData: FormData) => {
    const result = await unassignCampaignsAction(formData);
    if (result.success) {
      closeUnassignDialog();
      setUserRowSelectionModel({
        ids: new Set<GridRowId>([]),
        type: "include",
      });
      setRowSelectionModel({
        ids: new Set<GridRowId>([]),
        type: "include",
      });
    } else {
      console.error("Error unassigning campaigns:", result.error);
    }
  };

  const userIds = Array.from((userRowSelectionModel?.ids as Set<number>) ?? []);

  return (
    <NextForm action={handleAction}>
      {campaignIdsToUnassign.map((id) => (
        <input key={id} type="hidden" name="campaignIds" value={id} />
      ))}
      {userIds.map((userId) => (
        <input key={userId} type="hidden" name="userIds" value={userId} />
      ))}
      {children}
    </NextForm>
  );
}
